import HelperService from "../services/helper-service";
import Section from "./section";

export default function PageTitle ({className, children, ...props}) {
  return (<>
    <Section animation={HelperService.getRandomAnimation()} className={`mt-3 ${className}`}>
      <h2>{children}</h2>
    </Section>
  </>)
}
